<section>
  <div class="logo">
    <img src="assets/img/sign-up/logo.svg" alt="">
  </div>
  <div class="content">
    <div class="signup-container">
      <div class="signup-title">
        <div class="signup">
          <button routerLink="/login">
            <img src="assets/img/info-screen/arrow-left-line.png" alt="Back Button">
          </button>
          <h1>Sign up</h1>
          <div class="empty-space"></div>
        </div>
        <div class="line-container">
          <div class="line"></div>
        </div>
      </div>

      <div class="signup-form">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="username-input allInputs" >
            <input type="text" placeholder="Name" maxlength="30" formControlName="username" [class.error-border]="form.get('username')?.invalid && form.get('username')?.touched" pattern="^([a-zA-ZäöüÄÖÜß]+\.?(-[a-zA-ZäöüÄÖÜß]+\.?)*\s+)+[a-zA-ZäöüÄÖÜß]+\.?(-[a-zA-ZäöüÄÖÜß]+\.?)*$" required>
            <img  class="absoluteimg" src="assets/img/sign-up/person.svg" alt="">
          </div>
          
          <div class="mail-input allInputs">
            <input type="email" placeholder="Email" maxlength="30" formControlName="email" [class.error-border]="form.get('email')?.invalid && form.get('email')?.touched"  required pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}">
            <img class="absoluteimg" src="assets/img/sign-up/mail.png" alt="">
          </div>
          
          <div class="password-input allInputs">
            <input #pwInput [type]="showPassword ? 'text' : 'password'" placeholder="Password" maxlength="30" formControlName="password" (focus)="isFocused = true " (blur)="isFocused = false" (input)="checkPasswordInput()" 
            [class.error-border]="form.get('password')?.invalid && form.get('password')?.touched" minlength="6">
            <img  [src]="lockIconSrc" alt="Lock Icon" class="absoluteimg" (click)="checkLockClick(pwInput)">
          </div>

          <div class="confirm-password allInputs">
            <input maxlength="30" #pwInput [class.error-border]="(form.get('password')?.value !== form.get('confirmPassword')?.value && form.get('confirmPassword')?.touched) || (form.get('confirmPassword')?.invalid && form.get('confirmPassword')?.touched)" [type]="showPassword ? 'text' : 'password'" placeholder="Confirm Password" formControlName="confirmPassword" (focus)="isFocused = true" (blur)="isFocused = false" (input)="checkPasswordInput()" required>
            <img  [src]="lockIconSrc" alt="Lock Icon" class="absoluteimg" (click)="checkLockClick(pwInput)">
          </div>
          
          <div class="error-message all-inputs">
            @if (form.get('username')?.invalid && form.get('username')?.touched) {
            <p>You need firstname & lastname</p>
            }
            @if (form.get('password')?.value !== form.get('confirmPassword')?.value && form.get('confirmPassword')?.touched) {
            <p>Your passwords don't match.</p>
            }
            @if(form.get('email')?.invalid && form.get('email')?.touched){
            <p>Invalid email format.</p>
            }
          </div>

          <div class="required checkbox-privacy">
            <div class="custom-checkbox">
              <input formControlName="checkbox" maxlength="30" type="checkbox" id="privacy" name="privacy" required />
              @if(form.get('checkbox')?.touched && form.get('checkbox')?.invalid){
                <span class="red">I accept the</span>
              }@else {
                <span>I accept the</span>
              }
              <a [routerLink]="'/privacy'">Privacy policy</a>
            </div>
            <span class="error-text hidden">You must accept the Privacy policy</span>
            <button type="submit" class="register-button">Sign up</button>
          </div>

        </form>
      </div>


    </div>
  </div>
  <div class="legal-privacy">
    <span [routerLink]="'/privacy-sign-in'">Privacy Policy</span>
    <span [routerLink]="'/legal-notice-sign-in'">Legal notice</span>
  </div>
</section>